import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import ChallengeImage from './ChallengeImage';
import chevronRight from 'img/chevron-right.png';
import NavigationService from 'support/navigation/NavigationService';
import * as pages from 'common_constants/Pages';
import { getChallengeStatus } from 'services/GetStatusStyle';
import ExpiryInfo from './ExpiryInfo';
// import { getInitiativeFlag } from './View';

const useStyles = makeStyles((theme) => ({
  root: { width: '100%' },
  heading: {
    fontFamily: 'VodafoneRg-Regular',
    fontSize: '1.125rem',
    marginBottom: '8px',
    textAlign: 'left',
  },
  cardBox: {
    width: '100%',
    border: '1px solid #CCCCCC',
    height: '215px',
    margin: '0',
    display: 'flex',
    gap:'8px',
    overflow: 'hidden',
    borderRadius: '16px',
    gridTemplateColumns: '1fr 1fr',
    position:'relative'
  },
 
  selectedChallenge: {
    boxShadow: '-3px 4px 1px #ec2828',
  },
  selectbtn: {
    color: '#fff',
    cursor: 'pointer',
    border: '1px solid #e60000',
    display: 'block',
    padding: '0.5rem',
    fontSize: '1rem',
    boxSizing: 'border-box',
    textAlign: 'center',
    transition: 'all 300ms ease',
    fontFamily: 'VodafoneRg-Regular',
    borderRadius: '5px',
    backgroundColor: '#e60000',
  },
  block1: {
      maxWidth:'49%',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },
  block2: {
    marginLeft: '1rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    maxWidth:'49%'
  },
  textsmall: {
    fontFamily: 'VodafoneRg-Regular',
    margin: 0,
    fontSize: '0.8rem',
    textAlign: 'left',
    color: '#333',
    lineHeight: '1.4',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '& span': {
      fontFamily: 'VodafoneRg-Bold',
    },
  },
  linkBtn: {
    fontSize: "16px",
    fontFamily: theme.fontFamily.fontFamilyRegular,
    margin: "8px 0",
    display: "flex",
    alignItems: "center",
    paddingLeft: '8px',
    paddingRight: '8px',
    marginTop: "6px",
    color: "#6551FF",
  },
  draftstatus:{
    padding:'6px 18px',
    borderTopLeftRadius:'10px',
    borderTopRightRadius:'10px',
    backgroundColor:'#E60000',
    display:'inline-block',
    fontSize:theme.fontSize.fontsize16,
    fontFamily:theme.fontFamily.fontFamilyRegular,
    color:'#fff',
    '@media (max-width:767px)':{
      fontSize:'12px',
      padding:'4px 14px'
    }
  },
  flags:{
    fontSize: '0.8rem',
    padding:'8px',
    margin: '0px',
    background: '#f63f40',
    color: '#fff',
    borderRadius: '20px',
    fontWeight: '700',
    position: 'absolute',
    left: '1rem',
    top: '3rem'
  },

  expiry_box: {
    backgroundColor: "#666796",
    border: "1px solid #FFFFFF",
    borderRadius: "3px",
    opacity: 0.95,
    height: "50px",
    width: "142px",
    position: "relative",
    top: -66,
    left: 16,
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    "&.expired": {
      backgroundColor: "#FFFFFF",
      border: "1px solid black",
    },
    '@media (max-width:767px)':{
      height:'34px',
      width: '80%',
      top: 'inherit',
      bottom: '46px',
    }
  },
  expiry_text: {
    fontFamily:theme.fontFamily.fontFamilyRegular,
    color: "#FFFFFF",
    fontSize: "12px",
    padding: 0,
    paddingTop: "2px",
    paddingBottom: "2px",
    margin: 0,
    marginLeft: "6px",
    "&.expired": {
      color: "black",
    },
    '@media (max-width:767px)':{
      fontSize:'10px'
    }
  },
  bold_expiry: {
    fontSize: "13px",
    fontFamily: theme.fontFamily.fontFamilyBold,
    "&.expired": {
      color: "#6551FF",
    },
    '@media (max-width:767px)':{
      fontSize:'11px'
    }
  },


  
}));

const InnovateChallengeCard = (props) => {
  const classes = useStyles();
  const {
    urlID = '',
    challengeTitle = 'Untitled Challenge',
    onClick = () => { },
    selectedChallengeId = null,
    singleChallengeId = null,
    images = '',
    submissionsEnd = 'N/A',
    decs = 'No description available',
    selectedChallengeButtonDisbale = false,
    myChallengeStatus,
    status,
    isInnovate,
    isHackathonChallenge,
    innovateChallengeTagIdeaCount,
    EndDate
  } = props || {};
  // console.log("🚀 ~ InnovateChallengeCard ~ props:", props)
  // const isHackthonCheck = getInitiativeFlag({isHackathonChallenge,isInnovate})
  const { name: statusStr, color: statusCol } = getChallengeStatus(status);

  const ROUTES = NavigationService.getRoutes();
  const detailChallengePath = ROUTES?.[pages.DETAIL_CHALLENGE]?.pathWithOutID || '/challenge';
  //   let className = '';
  //   if (!selectedChallengeButtonDisbale && selectedChallengeId === singleChallengeId) {
  //     className = classes.selectedChallenge;
  //   }

  const className = (!selectedChallengeButtonDisbale && selectedChallengeId === singleChallengeId)
    ? classes.selectedChallenge
    : '';

  try {
    return (
      <div>
        {myChallengeStatus && (
          <div className={classes.draftstatus} style={{ backgroundColor: statusCol }}>
            {statusStr}
          </div>
        )}
      <div className={`${classes.cardBox} ${className }`}   style={{ borderTopLeftRadius: myChallengeStatus ? '0px' : undefined,  border: `2px solid ${statusCol}`}} >
        
        <div className={classes.block1}>
          <ChallengeImage src={images} />
          <ExpiryInfo ends={EndDate} numIdeas={innovateChallengeTagIdeaCount} classes={classes} myChallengeHide={false} />
          {/* <h4 className={classes.flags}>{isHackthonCheck}</h4>   */}
        </div>
        <div className={classes.block2}>
          <h3 className={classes.heading}>{challengeTitle}</h3>
          <p className={classes.textsmall}>
            <span>Description</span>: {decs}
          </p>
          <p className={classes.textsmall}>
            <span>Submissions End</span>: {submissionsEnd}
          </p>


          <Link className={classes.linkBtn} to={`${detailChallengePath}/${urlID}`}>
            View Details  <img src={chevronRight} alt="rightarrow" className={classes.arrowright} />
          </Link>

          {!selectedChallengeButtonDisbale &&
            (selectedChallengeId !== singleChallengeId ? (
              <button type="button" onClick={onClick} className={classes.selectbtn}>
                Select
              </button>
            ) : (
              <button type="button" className={classes.selectbtn}>
                Selected
              </button>
            ))}
        </div>
      </div>
      </div>
    );
  } catch (error) {
    console.error('Error rendering InnovateChallengeCard:', error);
    return <div>Error loading challenge card.</div>;
  }
};

export default InnovateChallengeCard;
